import { useMemo, useEffect } from 'react';

import { useSports } from 'contexts/SportContext';
import { ColumnIds } from 'enums';

import { usePaginationQueryParams } from './usePaginationQueryParams';

export const useSportFilterUpdate = (filters: Array<PaginationFilter>): Array<PaginationFilter> => {
  const { currentSport } = useSports();
  const { handlePaginationQueryParamsChange } = usePaginationQueryParams();

  const updatedFilters = useMemo(() => {
    const updatedFilters = currentSport
      ? filters.filter((item: PaginationFilter) => item.columnId !== ColumnIds.SportName)
      : filters;

    return updatedFilters;
  }, [currentSport, filters]);

  useEffect(() => {
    // use filters length as a quick check that filters contains sport name filter
    if (currentSport && filters.length !== updatedFilters.length) {
      handlePaginationQueryParamsChange({ filters: updatedFilters });
    }
  }, [currentSport, filters.length, handlePaginationQueryParamsChange, updatedFilters]);

  return updatedFilters;
};
